import * as r from 'ramda';
import { createSelector } from 'reselect';

const mapOrderId = (order) => {
  // Handle both old format (string) and new format (object with Id and CanDelete)
  if (typeof order === 'string') {
    return { id: order, canDelete: false };
  }
  return {
    id: order.Id,
    canDelete: order.CanDelete === true,
  };
};

const mapDatasetRecord = ({
  Id: id,
  PublisherId: publisherID,
  Key: key,
  TimesUsed: timesUsed,
  MaxUsesAllowed: maxUsesAllowed,
  DatasetName: datasetName,
  Data: data,
  OrderIds: ordersIds,
}) => ({
  id,
  publisherID,
  key,
  timesUsed,
  maxUsesAllowed,
  datasetName,
  data,
  orders: (ordersIds ?? []).map(mapOrderId),
});

const getDatasetsBase = r.prop('datasets');

const getDatasetsList = r.pipe(getDatasetsBase, r.prop('list'));

const getDatasetsUpdate = r.pipe(getDatasetsBase, r.prop('update'));

export const getDatasetByIdRaw = (id) =>
  r.pipe(getDatasetsList, r.prop('Records'), r.find(r.propEq('Id', id)));

export const getDatasetById = (id) => r.pipe(getDatasetByIdRaw(id), mapDatasetRecord);

export const getDatasets = createSelector(
  getDatasetsList,
  ({
    Records: records,
    PageSize: pageSize,
    PageNumber: pageNumber,
    TotalCount: totalCount,
    TotalPages: totalPages,
  }) => ({
    pageSize: parseInt(pageSize),
    pageNumber: parseInt(pageNumber),
    totalCount,
    totalPages,
    records: r.map(mapDatasetRecord, records),
  })
);

const getDatasetFirstRecord = r.pipe(r.prop('records'), r.head, r.defaultTo({}));

export const getDatasetDataFields = createSelector(
  getDatasets,
  r.pipe(getDatasetFirstRecord, r.propOr({}, 'data'), r.keys)
);

export const getPublisherId = r.pipe(
  getDatasets,
  getDatasetFirstRecord,
  r.propOr(null, 'publisherID')
);

export const getUpdateDatasetDatasetToEdit = createSelector(
  getDatasets,
  r.pipe(getDatasetsUpdate, r.prop('datasetId')),
  (datasets, datasetToEditId) => r.find(r.propEq('id', datasetToEditId))(datasets.records)
);
